import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import useInventoryEnabled from '../businesses/useInventoryEnabled';
import { getVocabulary } from '../../services/catalog';
import { Vocabulary } from '../../types/catalog';

/** Porter's attributes and brands plus the shop's additions; refreshed on every product save. */
function useVocabulary<T = Vocabulary>(
  enabled = true,
  select?: (vocabulary: Vocabulary) => T,
) {
  const { user } = useUser();
  const inventoryEnabled = useInventoryEnabled();
  const businessId = user?.business?.id;

  return useQuery({
    queryKey: ['catalog-vocabulary', businessId],
    queryFn: () => getVocabulary(businessId!),
    enabled: enabled && inventoryEnabled && !!businessId,
    staleTime: Infinity,
    gcTime: Infinity,
    select,
  });
}

export default useVocabulary;
